import { useEffect } from 'react';
import { Colors } from '@blueprintjs/core';
import { useMapContext } from 'widgets/earthMap/contexts/mapContext';
import { LAYER_NAMES } from 'widgets/earthMap/constants/layerNames';
import { SEPARATED_SOURCE_NAME } from 'widgets/earthMap/constants/mapConstants';
import useIsVisible from '../useIsVisible';
import useCircleRadius from '../../circles/useCircleRadius';
import useCircleColor from '../../circles/useCircleColor';
import useHoverEvent from './useHoverEvent';
import useHoverOpacity from './useHoverOpacity';
import getSeparatedPointsParentLayer from 'widgets/earthMap/helpers/getSeparatedPointsParentLayer';
import { DEFAULT_CIRCLE_RADIUS } from 'widgets/earthMap/constants/circleSizes';
import { DEFAULT_CIRCLE_COLOR } from 'widgets/earthMap/constants/circleColors';

const LAYER_NAME = LAYER_NAMES.SEPARATED_HOVERED_POINTS;

export default function useSeparatedHoverPoints() {
	const [{ map }] = useMapContext();

	useEffect(() => {
		if (!map) return;
		const source = map.getSource(SEPARATED_SOURCE_NAME);
		if (!source) return;
		map.addLayer(
			{
				id: LAYER_NAME,
				generateId: true,
				type: 'circle',
				source: SEPARATED_SOURCE_NAME,
				paint: {
					'circle-stroke-color': Colors.BLACK,
					'circle-stroke-width': 2,
					'circle-radius': DEFAULT_CIRCLE_RADIUS,
					'circle-color': DEFAULT_CIRCLE_COLOR,
				},
			},
			getSeparatedPointsParentLayer({ layerName: LAYER_NAME })
		);
		return () => {
			map.removeLayer(LAYER_NAME);
		};
	}, [map]);

	useCircleColor({ layerName: LAYER_NAME, sourceName: SEPARATED_SOURCE_NAME });
	useCircleRadius({ layerName: LAYER_NAME, sourceName: SEPARATED_SOURCE_NAME });
	useHoverEvent({ layerName: LAYER_NAME, sourceName: SEPARATED_SOURCE_NAME });
	useHoverOpacity({ layerName: LAYER_NAME, sourceName: SEPARATED_SOURCE_NAME });

	useIsVisible({ layerName: LAYER_NAME });
}
